import React from "react";
import {
  Stack,
  Typography,
  Card,
  Tooltip,
  Icon,
  IconButton,
  Alert,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "investira.react.components";
import { formats, validators } from "investira.sdk";
import AtivoTipoChart from "./AtivoTipoChart";

const AtivoTipoSection = (props) => {
  const { data } = props;

  const xResumo = data.response?.resumo;

  if (validators.isNull(xResumo)) {
    return null;
  }

  return (
    <>
      <Stack
        direction="column"
        sx={{ gap: 1 }}
        component="section"
        flexGrow={1}
      >
        <Stack gap={1} flexGrow={1}>
          <Card component={Paper}>
            <Stack px={2} py={2} flexGrow={1}>
              <Stack>
                <Typography variant="h6" color="textPrimary">
                  Distribuição por Tipo de Ativo
                </Typography>
              </Stack>
              <Stack
                sx={{ gap: 1, flexDirection: "row", alignItems: "center" }}
              >
                <Stack sx={{ flex: "1 1" }}>
                  <AtivoTipoChart data={xResumo.tipo_de_ativo} />
                </Stack>
                <Stack sx={{ flex: "1 1" }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Ativo Tipo</TableCell>
                        <TableCell align="right">Financeiro</TableCell>
                        <TableCell align="right">Participação (%)</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>FUNDO DE INV. EXTERIOR</TableCell>
                        <TableCell align="right">2.713.049,56</TableCell>
                        <TableCell align="right">6,6469</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>FUNDO DE INVEST,RENDA FIXA</TableCell>
                        <TableCell align="right">2.713.049,56</TableCell>
                        <TableCell align="right">6,6469</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>FUNDO INDICES,EMPRESTIMO</TableCell>
                        <TableCell align="right">2.713.049,56</TableCell>
                        <TableCell align="right">6,6469</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>FUNDOS INV. MULTIMERCADO</TableCell>
                        <TableCell align="right">2.713.049,56</TableCell>
                        <TableCell align="right">6,6469</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>NTN, TESOUR.NAC</TableCell>
                        <TableCell align="right">2.713.049,56</TableCell>
                        <TableCell align="right">6,6469</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>20 - FUNDOS DE,ÍNDICES</TableCell>
                        <TableCell align="right">2.713.049,56</TableCell>
                        <TableCell align="right">6,6469</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <b>Total</b>
                        </TableCell>
                        <TableCell align="right">
                          <b>2.713.049,56</b>
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
      </Stack>
    </>
  );
};

export default AtivoTipoSection;
